<template>
  <div
    class="base-element-rect"
    :style="{
      top: elementInfo.top + 'px',
      left: elementInfo.left + 'px',
      width: elementInfo.width + 'px',
      height: elementInfo.height + 'px',
    }"
  >
    <div
      class="rotate-wrapper"
      :style="{ transform: `rotate(${elementInfo.rotate}deg)` }"
    >
      <div
        class="element-content"
        :style="{
          transform: flipStyle,
        }"
      >
        <SvgWrapper
          overflow="visible"
          :style="{
            opacity: elementInfo.opacity,
            filter: shadowStyle ? `drop-shadow(${shadowStyle})` : '',
            fontFamily: `Noto Sans S Chinese Regular`,
          }"
          :width="elementInfo.width + elementInfo.strokeWidth * 2"
          :height="elementInfo.height + elementInfo.strokeWidth * 2"
        >
          <defs v-if="elementInfo.gradient">
            <GradientDefs
              :id="`editabel-gradient-${elementInfo.id}`"
              :type="elementInfo.gradient.type"
              :rotate="elementInfo.gradient.rotate"
              :color="elementInfo.gradient.color"
              :postion="elementInfo.gradient.radialPostion"
              :gradient="elementInfo.gradients || []"
            />
          </defs>
          <rect
            :x="elementInfo.strokeWidth"
            :y="elementInfo.strokeWidth"
            :rx="elementInfo.radius"
            :ry="elementInfo.radius"
            :width="elementInfo.width"
            :height="elementInfo.height"
            :stroke="elementInfo.stroke"
            :stroke-width="elementInfo.strokeWidth"
            :fill="
              elementInfo.gradient
                ? `url(#editabel-gradient-${elementInfo.id})`
                : tinycolor(elementInfo.fill)
            "
            :stroke-dasharray="elementInfo.strokeDasharray === 'dashed' ? '10 6' : '0 0'"
          ></rect>
        </SvgWrapper>
        <div class="shape-text" :class="text.align">
          <div class="ProseMirror-static" v-html="text.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";
import { PPTRectElement, ShapeText } from "@/types/slides";
import useElementShadow from "@/views/components/element/hooks/useElementShadow";
import useElementFlip from "@/views/components/element/hooks/useElementFlip";

import GradientDefs from "./GradientDefs.vue";
import tinycolor from "tinycolor2";
export default defineComponent({
  name: "base-element-Rect",
  components: {
    GradientDefs,
  },
  props: {
    elementInfo: {
      type: Object as PropType<PPTRectElement>,
      required: true,
    },
  },
  setup(props) {
    const shadow = computed(() => props.elementInfo.shadow);
    const { shadowStyle } = useElementShadow(shadow);

    const flipH = computed(() => props.elementInfo.flipH);
    const flipV = computed(() => props.elementInfo.flipV);
    const { flipStyle } = useElementFlip(flipH, flipV);

    const text = computed<ShapeText>(() => {
      const defaultText: ShapeText = {
        content: "",
        defaultFontSize:'20px',
        defaultFontName: "Noto Sans S Chinese Regular",
        defaultColor: "#000",
        align: "middle",
      };
      if (!props.elementInfo.text) return defaultText;

      return props.elementInfo.text;
    });
    return {
      shadowStyle,
      flipStyle,
      text,
      tinycolor,
    };
  },
});
</script>

<style lang="scss" scoped>
.base-element-rect {
  position: absolute;
}
.rotate-wrapper {
  width: 100%;
  height: 100%;
}
.element-content {
  width: 100%;
  height: 100%;
  position: relative;
  cursor: move;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    transform-origin: 0 0;
    overflow: visible;
    position: absolute;
  }
}
.shape-text {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 10px;
  line-height: 1.2;
  word-break: break-word;

  &.top {
    justify-content: flex-start;
  }
  &.middle {
    justify-content: center;
  }
  &.bottom {
    justify-content: flex-end;
  }
}
</style>
